export default class SessionUtil {
 static isLoggedIn() {
    const token = SessionUtil.getToken()
      ? SessionUtil.getToken()
      : undefined;
      
    if (!token) {
      return false;
    }
    //add 1 hour

    return !!localStorage.getItem('token');
  }

  static getToken() {
    return localStorage.getItem('token');
  }

  static setToken(token) {
    localStorage.setItem('token', token);
  }

  static removeToken() {
    localStorage.removeItem('token');
  }

  static getTypeUser() {
    return localStorage.getItem('typeUser');
  }

  static setTypeUser(typeUser) {
    localStorage.setItem('typeUser', typeUser);
  }

  static removeTypeUser() {
    localStorage.removeItem('typeUser');
  }

  static getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  static setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  static removeUser() {
    localStorage.removeItem('user');
  }

  static getUserId() {
    const user = SessionUtil.getUser();
    return user?.Id ?? null;
  }

  static logout() {
    SessionUtil.removeToken();
    SessionUtil.removeUser();
    SessionUtil.removeTypeUser();
    window.location.href = '/';
  }

  static setLang(lang) {
    sessionStorage.setItem('lang', lang);
  }

  static getLang() {
    return sessionStorage.getItem('lang') || 'en';
  }
}
